import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from './WellManagement.module.scss';

interface WellManagementPopUpProps {
  open: boolean;
  onClose: () => void;
  modalOpen: string;
  popupName: string;
  handleClickPopup: () => void;
}

const WellManagementPopUp: React.FunctionComponent<WellManagementPopUpProps> = ({
  open,
  onClose,
  modalOpen,
  popupName,
  handleClickPopup,
}) => {
  const intl = useIntl();

  return (
    <Dialog
      aria-labelledby="well-management-dialog"
      open={open}
      maxWidth="xl"
      scroll="body"
      classes={{ paperWidthXl: styles.paperWidthXS, root: styles.root }}
      data-testid="well-management-dialog"
    >
      <MuiDialogContent classes={{ root: styles.contentRoots }}>
        <div className={styles.infoTextGridPopup}>{`Are you sure you want to 
          save
         ${popupName}?`}</div>

        <div className={styles.buttonGroups}>
          <Button
            className={styles.linkButton}
            onClick={() => handleClickPopup()}
            data-testid="action-save-button"
          >
            <span className={styles.linkButtonText}>
              {intl.formatMessage({ id: 'wellGuardian.allWells.yes' })}
            </span>
          </Button>
          <Button
            className={styles.linkButton}
            onClick={() => onClose()}
            data-testid="action-save-button"
          >
            <span className={styles.linkButtonText}>
              {intl.formatMessage({ id: 'wellGuardian.allWells.no' })}
            </span>
          </Button>
        </div>
      </MuiDialogContent>
    </Dialog>
  );
};

export default WellManagementPopUp;
